module.exports = __webpack_public_path__ + "img/adobe.90ce7151.svg";